import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const toastMessages = [
  { name: "Alex", location: "Berlin, DE", action: "upgraded to Pro 🚀" },
  {
    name: "Sophia",
    location: "Paris, FR",
    action: "just started with HeadLockr 🎉",
  },
  {
    name: "Liam",
    location: "London, UK",
    action: "secured their Strapi CMS 🔒",
  },
  {
    name: "Emma",
    location: "Amsterdam, NL",
    action: "enabled MFA with HeadLockr ✅",
  },
  {
    name: "Noah",
    location: "New York, US",
    action: "completed their first setup! 🎯",
  },
];

const ToastNotification = () => {
  const [showToast, setShowToast] = useState(false);
  const [toastContent, setToastContent] = useState(toastMessages[0]);

  useEffect(() => {
    let timeoutId;

    const showRandomToast = () => {
      setToastContent(
        toastMessages[Math.floor(Math.random() * toastMessages.length)]
      );
      setShowToast(true);

      setTimeout(() => {
        setShowToast(false);

        timeoutId = setTimeout(showRandomToast, getRandomInterval());
      }, 4000);
    };

    const getRandomInterval = () =>
      Math.floor(Math.random() * (120000 - 20000)) + 20000;
    timeoutId = setTimeout(showRandomToast, getRandomInterval());

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div
      className="toast-container position-fixed bottom-0 start-0 p-3"
      style={{ zIndex: 1050 }}
    >
      <AnimatePresence>
        {showToast && (
          <motion.div
            key="toast"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className="toast show"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              minWidth: "280px",
              background: "#1c1c1c",
              color: "#fff",
              borderRadius: "8px",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
            }}
          >
            <div
              className="toast-header"
              style={{
                background: "#2a2a2a",
                color: "#fff",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              <strong className="me-auto">
                {toastContent.name} from {toastContent.location}
              </strong>
              <small>Just now</small>
            </div>
            <div className="toast-body">{toastContent.action}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ToastNotification;
